<template>
    <div style="text-align: center;">
        <div>
            <div style="font-size: 32px; font-weight: 700; line-height: 46px;">생년월일을 알려주세요</div>
            <div style="margin-top: 16px;">
                <div>
                    <input @click="showCalendar" class="common_input" readonly placeholder="날짜를 선택하세요" type="text" v-model="birth">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { REGIST_STEP } from '@/Constants';

export default {
    name: 'SignupBirthday',
    props: {
        showCalendar: {
            type: Function,
            default: () => { }
        },
        birth: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => {}
        },
        setBirthDate: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
    created() {
        if (this.mode === 'update') {
            if (this.registInfo.birth) {
                this.setBirthDate(this.registInfo.birth)
            }
        }
    }
}
</script>

<style scoped>
.common_input {
    width: 310px;
    height: 56px;
    outline: none;
    border-radius: 12px;
    border: none;
    padding: 0 12px;
}

.common_input::placeholder {
    font-size: 20px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>